import { getRequest } from './util';
var get = function () { return getRequest('/systeminfo/upcoming'); };
export default {
    get: get,
};
